import qs from 'qs';

type MessagingThreadLinkOptions = {
    /**
     * Open in single thread mode
     */
    singleThread?: boolean;
    /**
     * Open message form right away
     */
    openForm?: boolean;
    /**
     * Message source info for tracking
     */
    source?: string;
    traderaUserId?: number;
};

/**
 * Returns base path for a thread
 */
export const getMessagingThreadLink = (
    u1: number,
    u2: number,
    l: number,
    options?: MessagingThreadLinkOptions
): string => {
    const optionsWithDefaults = {
        singleThread: false,
        openForm: false,
        ...options
    };
    const { singleThread, ...queryParams } = optionsWithDefaults;
    return (
        (singleThread ? '/thread/' : '/threads/') +
        'u' +
        Math.min(u1, u2) +
        '_u' +
        Math.max(u1, u2) +
        '_l' +
        l +
        qs.stringify(queryParams, { addQueryPrefix: true })
    );
};

/**
 * Returns the path to a thread on Tradera's messaging page
 */
export const getMessagingPageLink = (
    u1: number,
    u2: number,
    l: number,
    options?: MessagingThreadLinkOptions
) =>
    'messaging' +
    (u1 && u2 && l ? getMessagingThreadLink(u1, u2, l, options) : '');
